import { m as s } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { b as a, c as r, d as e } from "../../../index-34b1f277.js";
const { definePartsStyle: o, defineMultiStyleConfig: d } = r(s.keys), i = a("modal-spacing"), t = a("modal-spacing"), n = a("modal-icon-size"), l = a("modal-icon-margin-left"), c = e({
  overflowY: "auto",
  paddingX: t.reference,
  paddingY: 1
}), g = e({
  position: "absolute",
  top: 0,
  right: 0,
  boxSize: "size-300",
  margin: "spacing-200"
}), p = e({
  position: "fixed",
  top: 0,
  left: 0,
  padding: "spacing-200",
  zIndex: "modal",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  sx: {
    [i.variable]: "space.spacing-200",
    [t.variable]: "space.spacing-300",
    [n.variable]: "sizes.4",
    [l.variable]: "space.3"
  }
}), f = e({
  maxHeight: `calc(100vh - ${i.reference} * 2)`,
  boxShadow: "400",
  borderRadius: "lg",
  backgroundColor: "white"
}), m = e({
  padding: t.reference
}), b = e({
  display: "flex",
  columnGap: "spacing-100",
  rowGap: "spacing-200",
  flexWrap: "wrap",
  justifyContent: { base: "center", sm: "inherit" },
  sx: {
    "button, a": {
      whiteSpace: "nowrap",
      width: "min-content"
    }
  }
}), h = e({
  justifyContent: "flex-start",
  fontSize: "2xl",
  fontWeight: 500,
  lineHeight: 1,
  padding: t.reference,
  paddingRight: `calc(${t.reference} + ${n.reference} + ${l.reference})`
}), y = e({
  display: "flex",
  gap: "spacing-50",
  alignItems: "center",
  justifyContent: "flex-start"
}), u = e({
  backgroundColor: "primaryAlpha.500"
}), x = o({
  body: c,
  closeButton: g,
  dialog: f,
  dialogContainer: p,
  footer: m,
  footerDefault: b,
  header: h,
  headerDefault: y,
  overlay: u
}), v = d({
  baseStyle: x,
  sizes: {
    sm: { dialog: { maxWidth: "500px" } },
    md: { dialog: { maxWidth: "650px" } },
    lg: { dialog: { maxWidth: "800px" } },
    xl: { dialog: { maxWidth: "1080px" } },
    full: {
      body: {
        flex: 1
      },
      dialog: { maxWidth: "100%", height: "100vh", margin: 0, borderRadius: 0, maxHeight: "100vh" },
      dialogContainer: { padding: 0 }
    }
  },
  defaultProps: {
    size: "sm"
  },
  variants: {
    bottomSheet: o({
      dialogContainer: {
        height: "fit-content",
        bottom: 0,
        top: "unset"
      },
      dialog: {
        position: "absolute",
        borderBottomRadius: "unset",
        bottom: 0,
        left: 0,
        right: 0
      }
    }),
    blurred: {
      overlay: {
        backdropFilter: "blur(6px)"
      }
    }
  }
});
export {
  v as Modal
};
//# sourceMappingURL=Modal.es.js.map
